import { type Result, unwrap } from "@maker/result";
import type { QueryClient } from "@tanstack/react-query";

function unwrapApi<T>(fn: Result<T>) {
	const data = unwrap(fn) as { data: T };

	return data;
}

function unwrapQuery<T>(queryClient: QueryClient, keys: unknown[]) {
	const query = queryClient.getQueryState<T>(keys);

	if (!query?.data || query.error) {
		throw new Error("Estado de consulta inválido");
	}

	return query.data;
}

export { unwrapApi, unwrapQuery };
